<script>
import { cmsasset } from "@kit/utils/Formats";

export const navbar = {
  //optional. if it will shrink on scroll
  scrollShrink: true, //false,

  subitemsRevealDuration: 0,

  //the mergeable classes for the outer fixed wrapper
  outerContainerClassesDesktop: "hta-nav-outer",
  outerContainerClassesMobile: "hta-nav-outer",

  backgroundColor: "var(--green-blue)",
  shrinkColor: "var(--green-blue)",

  logoWrapperClasses: "hta-logo-wrapper",

  hamburgerButtonClasses: "hta-hamburger-button",

  //the logo and aria text
  logoSrc: cmsasset("/cms-static-assets/HTA_NavLogo.png"),
  logoAriaAlt: "HTA navigation logo",

  desktopLayout: "banner",

  banner: {
    hasRightArea: false,
    hasLeftLogoArea: false,
    navAreaClasses: { override: "sb sb-v" },
    topAreaClasses: "sb-v",
  },

  //required
  height: "220px",
  shrinkHeight: "50px",

  padding: "14px",
  shrinkPadding: "5px",

  //optional. The top gap
  topGap: "0px",
};

export const sideDrawer = {
  topNavHeight: "50px",
  outerClasses: "hta-side-nav-drawer",
};

export default { name: "theme-navbar" };
</script>

<style>
.skiptranslate.goog-te-gadget {
  background-color: white;
  padding: 3px;
}

.navbar-subitems {
  background-color: var(--green-blue) !important;
}
a.hta-navbar-dropdown-option {
  color: white;
}
a.hta-navbar-dropdown-option:hover {
  text-decoration: underline;
}

/* Add --attop options for the nav item style */
.nav-top-option.navbar-item--attop,
.nav-top-option.nav-dropdown-item--attop {
  cursor: pointer;
  padding: 30px;
  padding-bottom: 20px;
  padding-top: 15px;
  z-index: 2;
  color: white !important;
  font-size: 1.7rem;
  font-family: "interstate-condensed", sans-serif;
  font-weight: 700;
}
.nav-top-option {
  cursor: pointer;
  padding: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
  font-size: 1.1rem;
  font-family: "interstate-condensed", sans-serif;
  color: white !important;
}
.nav-top-option:hover {
  text-decoration: underline;
}

a.nav-top-option.router-link-exact-active {
  color: white;
}

.hta-top-nav-subitems.navbar-subitems > .sb {
  background: #eeeeee;
  color: #555555;
  padding: 5px 15px 5px 15px;
  font-weight: normal;
}
.hta-top-nav-routes-subitems {
  width: 300px !important;
}
.hta-top-nav-routes-subitems > a {
  font-size: 1rem !important;
  padding: 10px !important;
  font-weight: bold !important;
  text-decoration: none !important;
}

.navbar-banner-top-area.navbar-banner-top-area--attop .hta-desktop-logo-container {
  height: 70px !important;
  padding-left: 60px;
}
.navbar-banner-top-area .hta-desktop-logo-container {
  height: 25px !important;
  padding-left: 20px;
  margin-bottom: 10px;
  margin-top: 15px;
}

/* 
add --attop behavior for the nav area. We're going to 
shift it over and up so that it's one line */
.navbar-banner-nav-area.navbar-banner-nav-area--attop {
  padding-right: 20px;
  transform: translateY(0px);
}
.navbar-banner-nav-area {
  padding-right: 100px;
  transform: translateY(-45px);
}

/* this is the logo wrapper that shows up in the mobile version of the navbar. */
.navbar-logo-wrapper {
  padding-left: 10px;
}

.hta-nav-main-searchoption {
  width: 100px !important;
}
.hta-nav-main-search-iconbutton {
  width: 80px !important;
}
.hta-nav-main-search-widget-button {
  width: 100px !important;
}
</style>
